var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef, useEffect } from 'react';
import { Falcon } from 'modules/macro';
import warning from 'warning';
import { Loader } from 'modules/v2/feedback/Loader';
import { ResetButton } from './components/ResetButton';
import { Input, InputContainer, Adornment } from './styled';
export const SearchInput = forwardRef((props, forwardedRef) => {
    const { value, onReset, disabled, onChange, resetLabel, variant = 'outline', stretch = false, invalid = false, loading = false, className } = props, rest = __rest(props, ["value", "onReset", "disabled", "onChange", "resetLabel", "variant", "stretch", "invalid", "loading", "className"]);
    if (__DEV__) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            warning(!(onChange && value && !onReset), '"onReset" function is required when using controlled searched');
            warning(!(onReset && !resetLabel), '"resetLabel" is required for accessibility when providing "onReset" function');
        }, [resetLabel, onChange, value, onReset]);
    }
    const showReset = Boolean(value && onReset && !disabled);
    const inputProps = Object.assign(Object.assign({}, rest), { value,
        onChange,
        disabled, ref: forwardedRef });
    return (<InputContainer $variant={variant} $invalid={invalid} $stretch={stretch} className={className}>
      <Adornment>
        <Falcon icon="magnifying-glass" $color="text.100"/>
      </Adornment>
      <Input type="search" {...inputProps}/>
      <Adornment>
        {loading ? <Loader size={6}/> : <ResetButton show={showReset} onClick={onReset} label={resetLabel}/>}
      </Adornment>
    </InputContainer>);
});
SearchInput.displayName = 'SearchInput';
